import React from "react";
import type { ActivityViewData } from "../types";
import type { ActivityItemOptions } from "../ui/types";
import { ActivityItemShell } from "../ui/ActivityItemShell";

/** Read-only informational item — no user actions. */
export function CIModelChangeItem({
    activity,
    itemOptions
}: {
    activity: ActivityViewData;
    itemOptions?: ActivityItemOptions;
}) {
    return (
        <ActivityItemShell
            title={activity.title}
            icon={activity.icon}
            showUnreadDot={!!itemOptions?.onMarkRead && !activity.read}
            timestamp={activity.createdAt}
            secondary={activity.description ?? undefined}
            onMarkRead={itemOptions?.onMarkRead}
            action={itemOptions?.action}
        />
    );
}
